"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        Globalize.addCultureInfo("en", {
            messages: {
                Input_InvalidTimeValue: "'{0}' is not a valid Time. Please enter time in {1} format.",
                Input_TimeAriaLabel: "Time Input",
            }
        });
        /**
         * Framework class for Time controls
         */
        var Time = /** @class */ (function (_super) {
            __extends(Time, _super);
            function Time() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            Object.defineProperty(Time.prototype, "MidnightString", {
                /**
                 * Midnight representation as a string in the display format
                 */
                get: function () {
                    if (!this._midnightString) {
                        // Get a Moment, don't pass in a Year, Month, or Day
                        // since we only want time.
                        // Use the UTC versions of the moment constructor since on days where DST changes,
                        // we don't want to represent times incorrectly.
                        var timeAsDate = moment.utc({ hour: 0, minute: 0, second: 0 });
                        var formats = $dyn.value(this.timeFormatPattern);
                        if (formats && formats.display) {
                            this._midnightString = timeAsDate.format(formats.display);
                        }
                    }
                    return this._midnightString;
                },
                enumerable: false,
                configurable: true
            });
            Time.prototype.init = function (data, element) {
                var _this = this;
                this.timeFormatPattern = $dyn.computed(function () {
                    return $dyn.util.getTimeFormat(_this);
                });
                _super.prototype.init.call(this, data, element);
                $dyn.observe(this.timeFormatPattern, function () {
                    _this._midnightString = undefined;
                });
            };
            Time.prototype.getFormattedValue = function () {
                var isValid = $dyn.peek(this.IsValid);
                var timeValue = this._parsedValue;
                // If the controls is in an invalid state we want to keep showing the user entered value.
                var timeString = isValid ? "" : this._lastUserValue;
                if (isValid || timeString === undefined) {
                    timeString = this._formatTimeValueForDisplay(timeValue, timeString);
                }
                return timeString;
            };
            Time.prototype.setFormattedValue = function (userValue, forceChange, forceCommandCall) {
                if (forceChange === void 0) { forceChange = false; }
                if (forceCommandCall === void 0) { forceCommandCall = false; }
                var logMessages = this.shouldControlLogMessage(userValue);
                this._lastUserValue = userValue;
                var newValue = this.parseTime(userValue);
                var result;
                if (forceChange || newValue !== this._parsedValue || !$dyn.peek(this.IsValid)) {
                    if (newValue !== undefined) {
                        this._parsedValue = newValue;
                        if (this.ReferenceGroup && $dyn.peek(this.ReferenceGroup.isFocused)) {
                            this.ReferenceGroup.isChildDataDirty = true;
                        }
                        else {
                            result = this.setValue(newValue.toString(), forceChange, forceCommandCall);
                        }
                    }
                    else {
                        result = $.Deferred();
                        result.reject();
                        if (logMessages) {
                            this._keepMessageID = this.warn($dyn.format($dyn.label("Input_InvalidTimeValue"), userValue, this.timeFormatPattern().display), "Input_InvalidTimeValue");
                        }
                        this._lastValidationResult = false;
                        this.IsValid(false);
                    }
                    if (logMessages) {
                        this.removeMessagesAsync();
                    }
                }
                else {
                    result = $.Deferred();
                    result.reject();
                }
                return result;
            };
            Time.prototype.isMandatoryMet = function () {
                var met = true;
                if ($dyn.value(this.formattedValue) == null ||
                    $dyn.value(this.formattedValue) === "" ||
                    $dyn.value(this.formattedValue) === this.MidnightString ||
                    $dyn.value(this.formattedValue) === "0") {
                    met = false;
                }
                return met;
            };
            Time.prototype.displayedValue = function () {
                var displayedValue;
                if (this.$inputElement && this.$inputElement[0]) {
                    displayedValue = this.$inputElement[0].value;
                }
                else {
                    // this is the case for all the xLabel Types
                    var value_1 = $dyn.value(this.Value);
                    displayedValue = typeof value_1 === "number" ? value_1.toString() : value_1;
                }
                return displayedValue;
            };
            Time.prototype.compareToParsedValue = function (newValue) {
                var newValueAsNumber = typeof newValue === "number" ? newValue : parseInt(newValue, 10);
                return this._parsedValue === newValueAsNumber;
            };
            Time.prototype.updateParsedValue = function (newValue) {
                var newValueAsNumber = parseInt(newValue, 10);
                if (!isNaN(newValueAsNumber)) {
                    this._parsedValue = newValueAsNumber;
                }
            };
            Time.prototype.parsedValueToString = function () {
                if (this._parsedValue !== undefined) {
                    return this._parsedValue.toString();
                }
            };
            Time.prototype._formatAsDisplayValue = function (rawValue) {
                return this._formatTimeValueForDisplay(rawValue, "");
            };
            Time.prototype.lastValidFormattedValue = function () {
                return this._formatTimeValueForDisplay($dyn.value(this.Value));
            };
            Time.prototype.updateLastUserValue = function (newValue) {
                this._lastUserValue = typeof newValue === "number" ? newValue.toString() : newValue;
            };
            /**
             * Parses a string into a number of seconds
             * @param valueStr The string value to be parsed
             * @returns Number of seconds if able to parse, otherwise undefined
             */
            Time.prototype.parseTime = function (valueStr) {
                var timeAsSeconds;
                if (valueStr !== undefined && valueStr !== null) {
                    valueStr = valueStr.trim();
                    if ($dyn.value(this.TimeHours) && valueStr.substr(0, 2) === "24") {
                        // If the user enters a hour based time that begins with 24 we treat it as the end of day value.
                        timeAsSeconds = 86400;
                    }
                    else if ($dyn.value(this.TimeHours) && valueStr === "12") {
                        // If the user enters a hour based time that is just 12 with no other input we treat it as the middle of day value.
                        timeAsSeconds = 43200;
                    }
                    else {
                        var dateTime = void 0;
                        if (valueStr.trim().toLocaleUpperCase() === "T") {
                            // for Time control when we ask for 'T' (now) we want the relative local time, as this gets converted
                            // to seconds from midnight. We do not care about utc.
                            dateTime = moment().tz("User");
                        }
                        else {
                            // Use the UTC versions of the moment constructor since on days where DST changes,
                            // we don't want to represent times incorrectly.
                            dateTime = moment.utc(valueStr, $dyn.value(this.timeFormatPattern).parse);
                        }
                        if (dateTime && dateTime.isValid()) {
                            timeAsSeconds = 3600 * dateTime.hour() + 60 * dateTime.minute() + dateTime.second();
                        }
                    }
                }
                return timeAsSeconds;
            };
            /**
             * Transform a time value or string into a string in the display format
             * @param value The time value
             * @param timeString The default value to return if value is blank
             * @returns The time string in the display format
             */
            Time.prototype._formatTimeValueForDisplay = function (value, timeString) {
                // Need to allow 0 as a value, but all other falsy types are not treated as values.
                if (value !== null && value !== undefined && value !== "") {
                    var hours = void 0;
                    var minutes = void 0;
                    var seconds = void 0;
                    var timeValue = typeof value === "number" ? value : parseInt(value, 10);
                    if (timeValue >= 0 && timeValue < 86400) {
                        hours = Math.floor(timeValue / 3600);
                        minutes = Math.floor((timeValue - (hours * 3600)) / 60);
                        seconds = Math.floor(timeValue - (hours * 3600) - (minutes * 60));
                        // Get a Moment, don't pass in a Year, Month, or Day
                        // since we only want time.
                        // Use the UTC versions of the moment constructor since on days where DST changes,
                        // we don't want to represent times incorrectly.
                        var timeAsDate = moment.utc({ hour: hours, minute: minutes, second: seconds });
                        var formats = $dyn.value(this.timeFormatPattern);
                        if (formats && formats.display) {
                            timeString = timeAsDate.format(formats.display);
                        }
                    }
                    else if (timeValue === 86400) {
                        // Value is considered "midnight" of the next day and should be tansformed to 24:00:00 in both AM/PM and 24 Time.
                        if ($dyn.value(this.TimeHours)) {
                            var separator = $dyn.util.getTimeSeparator(this);
                            timeString = "24";
                            if ($dyn.value(this.TimeMinute)) {
                                timeString += separator + "00";
                            }
                            if ($dyn.value(this.TimeSeconds)) {
                                timeString += separator + "00";
                            }
                        }
                    }
                }
                return timeString;
            };
            return Time;
        }(controls.BaseInput));
        controls.Time = Time;
        Time.prototype.TimeFormat = $dyn.ui.autoValue;
        Time.prototype.TimeHours = true;
        Time.prototype.TimeMinute = true;
        Time.prototype.TimeSeconds = true;
        Time.prototype.TimeSeparator = $dyn.ui.autoValue;
        $dyn.adapter({ id: "TimeSummary", controlType: "Time", template: "SummaryField" });
        $dyn.adapter({ id: "TimeLabel", controlType: "Time", template: "Label" });
        $dyn.adapter({ id: "TimeCardCell", controlType: "Time", template: "CardCell" });
        var TimeCell = /** @class */ (function (_super) {
            __extends(TimeCell, _super);
            function TimeCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            TimeCell.prototype.updateValue = function () {
                return this._onChange();
            };
            TimeCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            TimeCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            TimeCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            TimeCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            TimeCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            TimeCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(TimeCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return TimeCell;
        }(Time));
        controls.TimeCell = TimeCell;
        $dyn.ui.addPropertiesToPrototype(TimeCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "Time", template: "InputCell" });
        $dyn.cellAdapter({ id: "Time", controlType: "TimeCell", template: "InputCellEditor", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Time.js.map
